
import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//库区列表
export async function getList(params) {
    return post(erpserver+'/storekq/getList', params, true)
}

//仓库下拉
export async function selectWarehouse(params) {
    return post(erpserver+'/storekq/selectWarehouse', params, true)
}

//库区保存
export async function save(params) {
    return post(erpserver+'/storekq/save', params, true)
}

//库区详情
export async function getDetails(params) {
    return post(erpserver+'/storekq/getDetails', params, true)
}

//删除验证
export async function beforeRemove(params) {
    return post(erpserver+'/storekq/beforeDelete', params, true)
}

//删除
export async function remove(params) {
    return post(erpserver+'/storekq/delete', params, true)
}